import {SystemMemoryProps} from "../models/SystemMemoryProps";
import {NavMenu} from "../components/GetNavMenu";
import React from "react";
import {Footer} from "../components/GetFooter";

export function About({memory}: SystemMemoryProps) {
    return (
        <>
            <NavMenu memory={memory} />

            <Footer data={[]} />
        </>
    )
}